
import { FC, useContext, useEffect } from 'react';

import ErrorContext from '@/context/ErrorContext';


const InvalidPage: FC = () => {

    const { addError } = useContext(ErrorContext);

    useEffect(() => {
        const error = new Error();
        error.message = "Invalid route";
        addError(error);

    }, [addError])

    return null;
}

export default InvalidPage